import { flow } from 'fp-ts/function';
import { deburr, toLower, trim } from 'lodash/fp';

export const normalizeSearchValue = flow(deburr, toLower, trim);
